/* eslint-disable max-len */
import React from "react"
import {  handleSystemConfig } from "../redux/systemConfigSlice"
import { useDispatch } from "react-redux"
import { dataService } from "../services/data.services"
import { useEffect } from "react"
import Profile from "./Profile"
export default function AdminSystemConfig(){
    const dispatch=useDispatch()
    useEffect(()=>{
        const fetchData=async()=>{
            try{
                let response
                response = await dataService.GetAPI(`system-configuration/`);
                if(response.data.status===200){
                    dispatch(handleSystemConfig(response.data.data))
                }
                
            }catch(err){

            }
           
        }
        fetchData()
        return () => {
            // Cleanup logic, if needed
        };
        
    },[])

    return(
        <>
            <Profile/>
        </>
    )
}